// extracted by mini-css-extract-plugin
export default {"giveADonation":"nav_giveADonation__cEXM1","navProducts":"nav_navProducts__ny+v2"};